import {Pipe, PipeTransform} from "@angular/core";
import {orderBy} from "lodash-es";

@Pipe({
    name: "orderBy",
    standalone: false
})
export class OrderByPipe implements PipeTransform {
    transform(value: Array<any>, field: string, reverse: boolean = false) {
        return orderBy(value, field, reverse ? 'desc' : 'asc');
    }
}
